import { render, staticRenderFns } from "./avm.vue?vue&type=template&id=370ce2e6&scoped=true&"
import script from "./avm.vue?vue&type=script&lang=js&"
export * from "./avm.vue?vue&type=script&lang=js&"
import style0 from "./avm.vue?vue&type=style&index=0&id=370ce2e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370ce2e6",
  null
  
)

/* custom blocks */
import block0 from "./avm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports